import { render } from "./AddEditAddressForm.vue?vue&type=template&id=4786e293"
import script from "./AddEditAddressForm.vue?vue&type=script&lang=js"
export * from "./AddEditAddressForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__